/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import QuoteTable from "../../../Tables/QuoteTable";
import Search from "../../../Common/Search";
import Sorting from "../../../Common/Sorting";
import { connect } from "react-redux";
import { quoteList } from "../../../../stores/actions/quote.actions.types";
import { sortingCodeList } from "../../../../utilities/enums/sorting";
import { touchSourceValues } from "../../../../utilities/enums";
import { BiLoaderAlt } from "react-icons/bi";
import Paginations from "../../../Common/Pagination";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";

const QuoteList = ({ quoteList, loading }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [firstTouchSource, setFirstTouchSource] = useState("");
  const [lastTouchSource, setLastTouchSource] = useState("");
  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [quotes, setQuotes] = useState([]);
  const [sorting, setSorting] = useState([
    {
      whom: "createdAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    getQuoteList(search, pagination.page, sorting);
  }, [search, sorting, pagination.page, firstTouchSource, lastTouchSource]);

  const getQuoteList = (q = search, page = pagination.page, sort = sorting) => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, quotes } = data?.data;
        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));
        setQuotes(quotes);
      }
    };

    let request = {
      callback,
      data: { q, page, sort, firstTouchSource, lastTouchSource },
    };
    quoteList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  return (
    <div>
      <MetaHead title={t("quote-list")} />
      <div className='flex flex-col sm:flex-row justify-end mb-3 gap-2'>
        <Search
          placeholder='Search Quotes'
          search={search}
          setSearch={setSearch}
        />
        <Sorting
          name={"First Touch Source"}
          values={touchSourceValues}
          onChange={setFirstTouchSource}
        />
        <Sorting
          name={"Last Touch Source"}
          values={touchSourceValues}
          onChange={setLastTouchSource}
        />
        <Sorting
          name={"Sort"}
          values={sortingCodeList}
          onChange={handleChangeSorting}
        />
      </div>

      {loading ? (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : quotes?.length ? (
        <>
          <QuoteTable quotes={quotes} getQuoteList={getQuoteList} />
        </>
      ) : (
        <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          Not found
        </div>
      )}
      <Paginations pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});
export default connect(mapStateToProps, {
  quoteList,
})(QuoteList);
